/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from './ButtonShell'

// The corner of every landing button is cut away diagonally. Because the
// buttons sit on top of photography we cut the corner out for real
// (clip-path) instead of masking it with a coloured triangle.
const StyledButton = styled.div`
  display: inline-block;
  position: relative;
  transition: transform 0.25s ease 0s;

  &:hover {
    transform: scale(1.05);
  }

  & > a,
  & > button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: unset;
    font-family: ${(props) => props.theme.font.family.main};
    font-weight: 400;
    line-height: 1.2;
    padding: 11px 20px;
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - ${(props) => props.notch}px),
      calc(100% - ${(props) => props.notch}px) 100%,
      0 100%
    );

    &::after {
      content: '';
      display: block;
      flex-shrink: 0;
      width: 0;
      height: 0;
      margin-left: 25px;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 12px solid currentColor;
    }

    @media (min-width: 992px) {
      font-size: 20px;
    }

    @media (max-width: 991.98px) {
      font-size: 16px;
    }
  }

  ${(props) =>
    props.variant === 'red' &&
    css`
      & > a,
      & > button {
        background-color: #d50021;
        color: #fff !important;
      }
    `}

  ${(props) =>
    props.variant === 'dark' &&
    css`
      & > a,
      & > button {
        background-color: ${props.theme.color.main};
        color: #fff !important;
      }
    `}

  ${(props) =>
    props.variant === 'outline' &&
    css`
      & > a,
      & > button {
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff !important;
      }

      /* Redraw the border along the diagonal that clip-path removed. The line
         is centred on the notch, so it lands exactly on the cut edge. */
      &::after {
        content: '';
        position: absolute;
        height: 2px;
        background: #fff;
        width: ${(props.notch * 1.415).toFixed(2)}px;
        right: ${(props.notch / 2 - (props.notch * 1.415) / 2).toFixed(2)}px;
        bottom: ${(props.notch / 2 - 1).toFixed(2)}px;
        transform: rotate(-45deg);
      }
    `}
`

function ButtonLanding({
  isAnchor,
  isCustom,
  to,
  target,
  children,
  className,
  variant = 'red',
  notch = 14,
}) {
  return (
    <StyledButton variant={variant} notch={notch} className={className}>
      {isCustom ? (
        children
      ) : (
        <ButtonShell to={to} isAnchor={isAnchor} target={target}>
          {children}
        </ButtonShell>
      )}
    </StyledButton>
  )
}

export default ButtonLanding
